// extracted by mini-css-extract-plugin
export default {"wrapper":"BallroomGrid_wrapper__MUWuO","header":"BallroomGrid_header__sbiAt","grid":"BallroomGrid_grid__CnCDW","empty":"BallroomGrid_empty__zN1LP"};